export default class OrderDetailsDialogModel {
    constructor() {
        this.documentNumber = '';
        this.werksDesc = '';
        this.deliveryPlace = '';
        this.driverName = '';
        this.vehicleRegistrationNumber = '';
        this.trailerRegistrationNumber = '';
        this.fuels = [];
    }

    static assign(from, to, t) {
        if (from) {
            to.documentNumber = from.documentNumber;
            to.werksDesc = from.werksDesc;
            to.deliveryPlace = from.deliveryPlace;
            to.driverName = from.driverName;
            to.vehicleRegistrationNumber = from.vehicleRegistrationNumber;
            to.trailerRegistrationNumber = from.trailerRegistrationNumber;
            to.fuels = from.fuels ? from.fuels : [];
        } else {
            to = new OrderDetailsDialogModel();
        }
    }

    static copy(from, t) {
        const to = new OrderDetailsDialogModel();
        OrderDetailsDialogModel.assign(from, to, t);
        return to;
    }
}
